export const DATALINK_STATUS = {
  inProgress: "In progress",
  initial: "Initial",
  done: "Done",
  deleted: "Deleted",
};
